// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"178":"item","680":"monster"}[chunkId] || chunkId) + "." + {"178":"40ead758","591":"552eb218","680":"ad4c7d4b"}[chunkId] + ".css";
};